import { HqlCode } from '@/components/hql/HqlCode';
import { Badge } from '@/components/ui/badge';
import { CircleCheck } from 'lucide-react';
import type { FC } from 'react';
import { BLOCKING_QUERY_FLAGS, QUERY_FLAG_LABELS, type QueryFlag } from '../appliesToStatus';

/**
 * A type's query at a glance: a green check beside the approved query when nothing needs a look, else
 * its flags (red when they keep it from every home, amber when they wait on a human) over the query it
 * has.
 */
export const QueryStatus: FC<{ query: string | undefined; flags: QueryFlag[] }> = ({ query, flags }) => (
    <div className="flex flex-col items-start gap-1.5">
        {flags.length > 0 ? (
            <div className="flex flex-wrap gap-1">
                {flags.map((flag) => (
                    <FlagBadge key={flag} flag={flag} />
                ))}
            </div>
        ) : null}
        {query ? (
            <div className="flex items-start gap-1.5">
                {flags.length === 0 ? (
                    <CircleCheck aria-label="Ready" className="mt-0.5 h-4 w-4 shrink-0 text-green-600" />
                ) : null}
                <HqlCode query={query} />
            </div>
        ) : null}
    </div>
);

const FlagBadge: FC<{ flag: QueryFlag }> = ({ flag }) =>
    BLOCKING_QUERY_FLAGS.includes(flag) ? (
        <Badge variant="destructive">{QUERY_FLAG_LABELS[flag]}</Badge>
    ) : (
        <Badge variant="outline" className="border-amber-300 bg-amber-50 text-amber-800">
            {QUERY_FLAG_LABELS[flag]}
        </Badge>
    );
